import React from "react";
import Container from "../../../../components/paper/container";
import { Col, Row, Space, Spin } from "antd";
import TabsSection from "../../../../components/property-listing/TabsSection";
import PropertyGrid from "../../../../components/property-listing/PropertyGrid";
import usePublicProperties from "../../../../hooks/property-listing/usePublicProperties";
import PopularCities from "../../../../components/property-listing/PopularCities";
import AppExperience from "../../../../components/property-listing/AppExperience";
import MarketingAndPress from "../../../../components/property-listing/MarketingAndPress";

const ExploreProperties = () => {
  const { properties, loading } = usePublicProperties();

  const petFriendly = properties.filter((p) => p.petsAllowed === true);

  const luxury = properties.filter((p) => {
    const rentValue = Number(p.rent?.replace(/[^\d]/g, ""));
    return rentValue > 3000;
  });

  const recent = properties.filter((p) => {
    const createdAt = new Date(p.createdAt);
    const now = new Date();
    const daysDiff = (now - createdAt) / (1000 * 60 * 60 * 24);
    return daysDiff <= 14;
  });

  return (
    <>
      <Container>
        <Space
          direction="vertical"
          size={32}
          style={{ width: "100%", paddingTop: "0px" }}
        >
          <Row gutter={[32, 32]}>
            <Col span={24}>
              {loading ? (
                <Spin />
              ) : (
                <TabsSection
                  tabs={[
                    {
                      key: "pet-friendly",
                      label: "Pet-friendly",
                      content: <PropertyGrid properties={petFriendly} />,
                    },
                    {
                      key: "luxury",
                      label: "Luxury",
                      content: <PropertyGrid properties={luxury} />,
                    },
                    {
                      key: "recent",
                      label: "New",
                      content: <PropertyGrid properties={recent} />,
                    },
                  ]}
                />
              )}
            </Col>
          </Row>

          <Row gutter={[32, 32]}>
            <Col span={24}>
              <PopularCities />
            </Col>
          </Row>

          <Row gutter={[32, 32]}>
            <Col span={24}>
              <AppExperience />
            </Col>
          </Row>

          <Row gutter={[32, 32]}>
            <Col span={24}>
              <MarketingAndPress />
            </Col>
          </Row>
        </Space>
      </Container>
    </>
  );
};

export default ExploreProperties;
